"use client";

import { useState } from "react";
import { faq } from "@/content";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 border-t border-ink-800 bg-ink-900 py-20 sm:py-24">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-ember-400">
          {faq.kicker}
        </p>
        <h2 className="mt-3 font-display text-3xl font-semibold text-parch-100 sm:text-4xl">
          {faq.heading}
        </h2>

        <div className="mt-10 divide-y divide-ink-700 border-y border-ink-700">
          {faq.items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={item.q}>
                <h3>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${i}`}
                    onClick={() => setOpen(isOpen ? null : i)}
                    className="flex w-full items-center justify-between gap-4 py-5 text-left focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ember-300"
                  >
                    <span className="font-display text-lg font-medium text-parch-100">
                      {item.q}
                    </span>
                    <span
                      aria-hidden="true"
                      className={`shrink-0 text-xl leading-none text-ember-400 transition-transform duration-200 ${
                        isOpen ? "rotate-45" : ""
                      } motion-reduce:transition-none`}
                    >
                      +
                    </span>
                  </button>
                </h3>
                <div
                  id={`faq-panel-${i}`}
                  hidden={!isOpen}
                  className="pb-6 pr-8 text-sm leading-relaxed text-parch-300 sm:text-[15px]"
                >
                  {item.a}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
